module.exports = __webpack_public_path__ + "img/thumbnail_AfricanElephant_f_normal.926b093a.png";